module.exports = __webpack_public_path__ + "media/images/kylas-mountain-58fd41f5a4a82db3b0965ade22847c7a.png";